import OfferSelectionScreen from 'features/rewards/SelfFundedOffers/OfferSelectionScreen';
import React from 'react';

export default function Page() {
  return <OfferSelectionScreen />;
}
